import { gateway } from "../../../../gateway";

export const getAllSupplies = async ({ token }) => {
  try {
    const res = await gateway.get(
      `/supplies/`,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};
